export const contactDetailsConfigurationModel = {
  Phone: "",
  Email: "",
  Address: "",
};
